import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {apiUrl,authorization,imgUrl} from './config/index'
import axios from './axios'
import './permission' // 路由守卫
import BaiduMap from 'vue-baidu-map'
import VueJsonp from "vue-jsonp"
import ElementUI from 'element-ui';
import BackTop from './components/backTop.vue'

// ===== CSS 导入（放在所有组件导入之后，确保加载顺序正确）=====
import 'element-ui/lib/theme-chalk/index.css';
import './assets/reset.css'
import './assets/huangyao_hd.css'
import './assets/iconfont/iconfont.css'

Vue.component('backTop', BackTop)
Vue.use(BaiduMap,{
  ak:'4sYF1d9bP1jEV2DqYHg5hPkePuZUpfuP'
})
Vue.use(VueJsonp)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.apiUrl = apiUrl
Vue.prototype.imgUrl = imgUrl
Vue.prototype.$axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
